export default __webpack_public_path__ + "static/media/metric_alert.bcd08fdd.svg";